import type { CardColor } from '../src/shared/cards';

export const CHAT_HISTORIES_KEY = 'kai.chat_histories.v2';
export const LANGUAGE_PREFERENCE_KEY = 'kai.language.v2';
export const WATCH_DATA_KEY = 'kai.youtube_watch.v2';

export const AUDIO_INACTIVITY_TIMEOUT_MS = 10_000;

export const CARD_THEME_MAP: Record<
  CardColor,
  { tile: string; header: string; surface: string; accent: string }
> = {
  green: { tile: 'bg-green-500', header: 'bg-green-500 text-white', surface: 'bg-green-50', accent: 'ring-green-400' },
  yellow: { tile: 'bg-yellow-500', header: 'bg-yellow-500 text-white', surface: 'bg-yellow-50', accent: 'ring-yellow-400' },
  red: { tile: 'bg-red-500', header: 'bg-red-500 text-white', surface: 'bg-red-50', accent: 'ring-red-400' },
  indigo: { tile: 'bg-indigo-500', header: 'bg-indigo-500 text-white', surface: 'bg-indigo-50', accent: 'ring-indigo-400' },
  pink: { tile: 'bg-pink-500', header: 'bg-pink-500 text-white', surface: 'bg-pink-50', accent: 'ring-pink-400' },
  cyan: { tile: 'bg-cyan-500', header: 'bg-cyan-500 text-white', surface: 'bg-cyan-50', accent: 'ring-cyan-400' },
  orange: { tile: 'bg-orange-500', header: 'bg-orange-500 text-white', surface: 'bg-orange-50', accent: 'ring-orange-400' },
  blue: { tile: 'bg-blue-500', header: 'bg-blue-500 text-white', surface: 'bg-blue-50', accent: 'ring-blue-400' },
  purple: { tile: 'bg-purple-500', header: 'bg-purple-500 text-white', surface: 'bg-purple-50', accent: 'ring-purple-400' },
  teal: { tile: 'bg-teal-500', header: 'bg-teal-500 text-white', surface: 'bg-teal-50', accent: 'ring-teal-400' },
  violet: { tile: 'bg-violet-500', header: 'bg-violet-500 text-white', surface: 'bg-violet-50', accent: 'ring-violet-400' },
};
